/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbUpIcon16Light = forwardRef('HandThumbUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.264 0C7.606 0 7.005.372 6.71.96L4.191 6H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h9.438a2.5 2.5 0 0 0 2.426-1.894l1.155-4.62A2 2 0 0 0 13.08 5H10V1.736C10 .777 9.223 0 8.264 0ZM5 13h6.438a1.5 1.5 0 0 0 1.456-1.136l1.155-4.621A1 1 0 0 0 13.079 6H9.5a.5.5 0 0 1-.5-.5V1.736a.736.736 0 0 0-1.394-.33L5 6.619V13ZM2 7h2v6H2V7Z" })));
});
